const TetherCnt = {
  symbol: "UNI",
  name: "uniSwap",
  meta: {
    title: "Buy UniSwap | Sell UniSwap | UniSwap prices and charts",
    description:
      "UNI digital currency (UNI) with the image of the famous unicorn is one of the most popular currencies in the market. Here is all the information you need to know about UniSwap cryptocurrencies and decentralized exchanges.",
    keywords: "UniSwap, buy UniSwap, sell UniSwap, UniSwap price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه یونی سواپ بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید یونی سواپ کنید. قیمت یونی سواپ در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول یونی سواپ کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "برای نگهداری یونی سواپ این کیف پول‌ها انتخاب‌های مناسبی هستند: کیف پول اتمیک (Atomic Wallet)، کیف پول سخت افزاری لجر (Ledger)، کیف پول متامسک (Metamask)، کیف پول تراست (Trust Wallet) و کیف پول فورماتیک (Fortmatic)",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین‌نیک مارکت امکان نگهداری ترون وجود دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید رمزارزهیاتان را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا یونی سواپ ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "یونی سواپ از همان روز اول، به پذیرش ارزهای دیجیتال در مقیاس گسترده کمک کرده است. در حال حاضر صرافی‌های غیرمتمرکز بسیاری وجود دارند که از استراتژی این پلتفرم منحصربه‌فرد کپی کرده‌اند. با این حال، هیچ یک از آنها به موفقیت‌های این شبکه غیرمتمرکز نرسیده‌اند. به همین دلایل، پیش‌بینی می‌شود یونی سواپ در سال‌های آتی همچنان ارزش زیادی در بازار داشته باشد.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy uniSwap",
      answer:
        "In coinnik Market trading platform, you can buy uniSwaps with Shetab member bank card and the lowest fee. The price of uniSwap in coinnik Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best uniSwap wallet?",
      answer: "UniSwap_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a uniSwap at coinnik Market?",
      answer: "Keep_uniSwap_description",
      id: "toggler3",
    },
    {
      question: "Is uniSwap worth the investment?",
      answer: "UniSwap_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about uniSwap",
        subTitle: "What is uniSwap?",
        content: "UniSwap_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of uniSwap",
        content: "UniSwap_history_description",
        btnTitle: "Buy and sell uniSwap",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell uniSwap without intermediaries in coinnik Market",
        subTitle: "Buy uniSwap",
        content: "Buy_uniSwap_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell uniSwap",
        content: "Sell_uniSwap_description",
        btnTitle: "Buy and sell uniSwap",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest uniSwap analysis on the blog",
  informationTitle: "uniSwap market statistics and information",
};

export default TetherCnt;
